<template>
  <div id="listWidget" class="mb-5">
    <ul class="breadcrumb">
      <li v-if="zone" class="breadcrumb-item">{{ zone?.name }}</li>
      <li class="breadcrumb-item active">{{ pageTitle }}</li>
    </ul>
    <div>
      <h4 class="mb-3">{{ pageTitle }}</h4>    
      <p class="mb-1">
        1. 조명제어기의 <code style="font-size: 100%">리셋(RESET) 버튼</code>을 길게 눌러서 세팅
        모드로 진입하시고 LED를 확인하십시오.
      </p>
      <p class="mb-1">
        2. <code style="font-size: 100%">조명제어기 AP 연결 버튼</code>을
        눌러서 조명제어기 AP에 접속하십시오.
      </p>
      <p class="mb-1">
        3. 연결된 조명제어기에 로컬 wifi 네트워크를 설정해주십시오.
      </p>
      <p class="mb-1">4. 연결된 조명제어기를 서버에 등록</p>
      <p>
        <code style="font-size: 100%"
          >※ 주의)조명제어기 설정시 한 장치만 활성화 되어 있어야합니다.</code
        >
      </p>

      <CardBody>
        <button
          type="button"        
          class="btn btn-primary"
          style="--bs-btn-padding-y: 0.16rem"
          @click="() => onConnect()"
        >조명제어기 AP 연결</button>
      </CardBody>
    </div>

    <hr
      class="mb-4"
      v-if="
        (settingParams && settingParams.name) || lightControllers.length > 0
      "
    />

    <h6 class="mb-3" v-if="settingParams && settingParams.name">
      wifi:{{ settingParams.name }}
    </h6>

    <div class="row">
      <ControllerItem
        v-for="(item, index) in lightControllers"
        :key="item._id"
        :index="index"
        :data="item"
        v-on:onDeleteClick="onReceivedDeleteClick"
      />
    </div>

    <!-- wifiConnectModal -->
    <PopDialog
      title="조명제어기 AP 연결정보 설정"
      :visible="wifiConnectModal.visible"
      :okCallback="onConnect"
      :cancelCallback="wifiConnectModal.hide"
      :okText="'연결'"
      :cancelText="'닫기'"
      :clickable="false"
    >
      <input
        type="text"
        class="form-control form-control-lg fs-15px"
        placeholder="ssid 입력해주세요."
        v-model="ap_wifi.ssid"
      />
      <input
        type="text"
        class="form-control form-control-lg fs-15px"
        placeholder="password 입력해주세요."
        v-model="ap_wifi.password"
      />
    </PopDialog>

    <!-- controllerWifiSettingModal -->
    <PopDialog
      title="조명제어기 Wifi 연결정보 설정"
      :visible="controllerWifiSettingModal.visible"
      :okCallback="onSettingAndRegist"
      :cancelCallback="controllerWifiSettingModal.hide"
      :clickable="false"
    >
      시리얼 넘버 : {{ connectedController._id }}<br />
      모델 코드 : {{ connectedController.model }}<br />
      펌웨어 버전 : {{ connectedController.version }}<br />

      <hr class="mb-3" />

      <input
        type="text"
        class="form-control form-control-lg fs-15px mb-2 col"
        placeholder="ssid 입력해주세요."
        v-model="settingParams.ssid"
      />
      <input
        type="text"
        class="form-control form-control-lg fs-15px col"
        placeholder="password 입력해주세요."
        v-model="settingParams.pwd"
      />
    </PopDialog>

    <!-- addControllerModal -->
    <PopDialog
      title="조명제어기 추가"
      :visible="addControllerModal.visible"
      :okCallback="onRegist"
      :cancelCallback="addControllerModal.hide"
      :clickable="false"
    >
      시리얼 넘버 :
      <input
        type="text"
        class="form-control form-control-lg fs-15px"
        v-model="connectedController._id"
      />
      모델 코드 :
      <input
        type="text"
        class="form-control form-control-lg fs-15px"
        v-model="connectedController.model"
      />
      펌웨어 버전 :
      <input
        type="text"
        class="form-control form-control-lg fs-15px"
        v-model="connectedController.version"
      />
    </PopDialog>
  </div>
</template>
<script setup>
import {
  ref,
  reactive,
  getCurrentInstance,
  onBeforeMount,
  computed,
  onMounted,
  onBeforeUnmount,
  watch,
  
} from 'vue';
import { useStore } from 'vuex';
import Axios, { ZoneApi, GroupApi, CtrlApi } from '@/api';

import { useRouter, useRoute ,onBeforeRouteLeave, onBeforeRouteUpdate } from 'vue-router';
import PopDialog from '@/common/components/popup/PopDialog.vue';
import useModal from '@/common/hooks/useModal';
import CardBody from '@/common/template/components/bootstrap/CardBody.vue';

import ControllerItem from './components/ControllerItem.vue';
import WifiItem from './components/WifiItem.vue';
import { MCApi } from '@/api/mcUrls';
import { DeviceDefault, SettingConfig } from '@/common/constants';
import apAxios from 'axios';
import useMobile from '@/common/hooks/useMobile';
import useMqttControl from '@/common/hooks/useMqttControl';
import { isAndroid } from 'mobile-device-detect';
import useControllerProvisioning from '@/common/hooks/useControllerProvisioning';

const mqttControl = reactive(useMqttControl());
const { emitter, mobile, logger } =
  getCurrentInstance().appContext.config.globalProperties;
const router = useRouter();
const route = useRoute();
const props = defineProps(['data']);
const store = useStore();
const account = computed(() => store.getters['account']);
const wifiConnectModal = reactive(useModal());
const controllerWifiSettingModal = reactive(useModal());
const addControllerModal = reactive(useModal());
const { requestTransferController, searchWifiList } = useMobile();
const { provisionOverWifiAp } = useControllerProvisioning();
const controllers = computed(() => store.getters['home/getLowVersionControllers']);
const zones = computed(() => store.getters['home/getZones']);

const pageTitle = computed(() => 
  route.path.includes('regist-controllers') 
    ? '조명제어기 등록' 
    : '조명제어기 설정'
);

const forceRoute = ref(false);

const zone = ref(undefined);
const lightControllers = ref([]);
let connectCount = 0;

let connectTimeoutId = undefined;
let settingTimeoutId = undefined;

const ap_wifi = ref({
  ssid: DeviceDefault.AP_SSID,
  password: DeviceDefault.AP_PWD,
});

// TODO : 서버에서 관리되는 모델의 펌웨어 버전 및 다운로드 url 적용 해야함.
const settingParams = ref({
  // ssid: 'MOTIZEN_5GHz',
  // pwd: 'motizen$$$',
  ssid : '',
  pwd :'',
  firmware_version: '',
  firmware_url: '',
  uuid: '',
  device_key: '',
  mqtt_url: process.env.VUE_APP_CTRL_MQTT_DOMAIN,
  mqtt_username: '',
  mqtt_password: '',
});

const connectedController = ref({
  _id: '',
  version: '',
  model: '',
});

onBeforeMount(() => {  
  emitter.emit('onChangeHeaderSetting',{title:'네트워크 설정',isShowMenu:false,isShowZone:false,isShowProfile:false});    
});
onBeforeUnmount(() =>{
  mobile.disConnectWifi(JSON.stringify(ap_wifi.value));  
  emitter.emit('onChangeHeaderSetting',{title:'',isShowMenu:true,isShowZone:true,isShowProfile:true});  
})
onMounted(() => {
  requestZone();
  console.log('ControllerSettingPage.onMounted => zone : ', zone.value);
});

watch(zone, () => {
  console.log('ControllerSettingPage.watch => zone : ', zone.value);
});

const setSettingModeOff = async () =>{
  forceRoute.value = true;
  const payload = {isEditMode:false}
  const result = await Axios.patch(
    ZoneApi.UPDATE_ZONE.replace(':id', zone.value._id),
    payload,
  );

  if (result.resultCode === '0000') {
    mqttControl.onPublishZone(zone.value._id,payload)
    store.dispatch('home/fetchAllZones');
  }
  // Promise가 resolve(true)되면 라우터가 자동으로 전환하므로 router.go(-1) 제거
};

onBeforeRouteLeave(async(to, from) => {
  if(to.path === '/settings/light/controllers'){
    if(forceRoute.value)return true;

    if (store.getters["isLoading"]) {
      emitter.emit('showPopConfirm', {
        description: '세팅이 진행중입니다.\n절차를 중지하고 세팅모드를 종료하시겠습니까?',
        okCallback: () => {
          allStopProcess();
          return true;
        },
      });
      return false;
    }

    // 세팅모드 종료 - Toast로 표시
    return new Promise(async (resolve) => {
      await setSettingModeOff();
      emitter.emit('showPopToast', {
        description: '세팅모드가 종료되었습니다.',
        type: 'success',
        autoHide: true,
        delay: 3000,
      });
      resolve(true);
    });
  }

  mobile.disConnectWifi(JSON.stringify(ap_wifi.value));
  return true;
});

const allStopProcess = () => {
  clearTimeout(connectTimeoutId);
  clearTimeout(settingTimeoutId);
  emitter.off('onConnectResult');
  emitter.off('onSettingResult');
  emitter.emit('hideLoading', true);
  mobile.disConnectWifi(JSON.stringify(ap_wifi.value));
  setSettingModeOff();
};

const reConnect = () => {
  if (connectCount > 4) {
    connectCount = 0;
    return;
  }

  emitter.emit('showLoading');
  connectTimeoutId = setTimeout(() => {
    connectTimeoutId = undefined;
    emitter.emit('hideLoading');
    onConnect(connectCount >= 4, connectCount);
    connectCount++;
  }, 5000);
};

// 컨트롤러 연결 :
const onConnect = async (showAlert = false, connectCount) => {
  console.log("showAlert", showAlert)
  wifiConnectModal.hide();
  // add event
  emitter.on('onConnectResultMsg', (payload) => {
    if (payload?.msg) {
      emitter.emit('appendLoadingText', payload.msg);
    }
  });
  
  emitter.on('onConnectResult', (payload) => {
    emitter.emit('hideLoading');

    // remove event
    emitter.off('onConnectResult');
    emitter.off('onConnectResultMsg');

    logger.log(`ControllerSettingPage.onConnect => onConnectResult : payload.result : ${payload.result}`);

    if(payload.result){

      try {
        let decoded = JSON.parse(decodeURIComponent(window.atob(payload.data)));
        logger.log(`ControllerSettingPage.onConnect => onConnectResult : decoded : ${JSON.stringify(decoded)}`);

        if (decoded) {
          if (decoded.message) {
            if (showAlert) {
              showPopAlert(decoded.message);
            }
            reConnect();
            return;
          }
          // connectedController.value = decoded.device
          let arr = decoded.device.serial_no.split('_');
          connectedController.value.model = arr[0];
          connectedController.value._id = decoded.device.serial_no;
          connectedController.value.version = decoded.device.version;
          // 컨트롤러가 통신할 local wifi 세팅 창을 연다.
          controllerWifiSettingModal.show();
          return;
        }
        return;
      } catch (e) {
        console.error(e);
        if (showAlert) {
          showPopAlert('조명제어기 연결에 실패하였습니다.');
        }
        reConnect();
        return;
      }
    } else {
      if (payload.resultCode === 1001) {
        showPopAlert("wifi가 켜져있지 않습니다.\nwifi를 켜고 다시 시도해주세요.");
        return;
      }
    }
    
    mobile.disConnectWifi(JSON.stringify(ap_wifi.value));
    if (showAlert) {
      showPopAlert('조명제어기 연결에 실패하였습니다.\n조명제어기가 셋팅모드로 되어 있는지 확인해주세요.');
    }
    reConnect();
  });

  logger.log(`ControllerSettingPage.onConnect => payload:${JSON.stringify({
    ssid: ap_wifi.value.ssid,
    password: ap_wifi.value.password,
    bssid: ap_wifi.value.bssid||undefined,
    callback: 'onConnectResult',
  })}`)

  // if (isAndroid) {
  //   let retryCount = 0;
  //   while(retryCount < 5) {
  //     let wifiList = [];
  //     try {
  //       wifiList = await searchWifiList();
  //     } catch (e) {
  //       console.log(e);
  //     }

  //     retryCount++;
  //     const targetWifi = wifiList.filter(wifi => wifi.ssid == ap_wifi.value.ssid);
  //     if (targetWifi.length === 0 && retryCount >= 5) {
  //       showPopAlert('셋팅모드의 조명제어기를 찾을 수 없습니다.\n조명제어기가 셋팅모드로 되어 있는지 확인해주세요.');
  //       return;
  //     }
  //   }
  // }
  
  mobile.connectWifi(
    JSON.stringify({
      ssid: ap_wifi.value.ssid,
      password: ap_wifi.value.password,
      bssid: ap_wifi.value.bssid||undefined,
      callback: 'onConnectResult',
    }),
  );
  emitter.emit('showLoading');
  emitter.emit('setLoadingText', connectCount === undefined ? '조명제어기에 연결하고 있습니다.' : `조명제어기에 ${connectCount + 2}번째 연결 시도하고 있습니다.`);
};

// 컨트롤러 설정 :
const onSetting = () => {
  return new Promise(async (resolve, reject) => {
    logger.log('ControllerSettingPage.onSetting => wifi : ' + settingParams.value);
    try {
      await provisionOverWifiAp({
        settingParams: settingParams.value,
        apWifi: ap_wifi.value,
      });

      const ownedZones = zones.value.filter(item => item.ownerId == account.value._id);
      const foundZones = ownedZones.filter(item => item.controllers.find(controller => controller._id == connectedController.value._id));
      if (foundZones.length > 0) {
        reject({
          resultCode: 2001,
          resultMessage: "현재 사용하고 있는 조명제어기입니다.\nwifi정보만 재설정 되었습니다."
        });
        emitter.emit('hideLoading', true);
        return;
      }

      resolve();
    } catch (e) {
      // preserve legacy behavior: callers expect string or {resultCode,...}
      if (e?.message) {
        reject(e.message);
      } else {
        reject(e);
      }
      emitter.emit('hideLoading', true);
    }
  });
};

// 컨트롤러 등록 :
const onRegist = async () => {
  const request = () => {
    return new Promise(async (resolve, reject) => {
      setTimeout(async () => {
        try {
          // const exControllerResult = await Axios.get(CtrlApi.CTRL_INFO.replace(':id', connectedController.value._id));
          // if(exControllerResult.resultCode === '0000'){
          //   if(exControllerResult.resultData) {
          //     reject("이미 등록된 컨트롤러입니다.")
          //     return;
          //   }      
          // }

          const result = await Axios.post(
            ZoneApi.REGIST_ZONE_CTRLS.replace(':id', route.params.zoneId),
            connectedController.value,
          );

          if (result?.resultCode === "0000") {
            await requestZone();
          }
          resolve(result);
        } catch (e) {
          resolve(e);
        }
      }, SettingConfig.requestInterval);
    });
  }

  return new Promise(async (resolve, reject) => {
    try {
      let result = undefined;
      for (let i = 0; i < SettingConfig.requestCount; i++) {
        emitter.emit('setLoadingText', i === 0 ? '조명제어기 정보를 서버에 등록중입니다.' : `조명제어기 정보를 서버에 ${i + 1}번째 등록 시도하고 있습니다.`);
        result = await request();
        if (result?.resultCode === "0000") {
          resolve();
          return;
        }
        if (result?.resultCode === "1001") {
          reject(result);
          emitter.emit('hideLoading', true);
          return;
        }
      }
      
      reject(result?.resultMessage?.length > 0 ? result.resultMessage : "조명제어기 등록에 실패했습니다.");
      emitter.emit('hideLoading', true);
    } catch (e) {
      console.log(e);
      reject("조명제어기 추가 중 오류가 발생하였습니다.")
      emitter.emit('hideLoading', true);
    }
  });
};

const onSettingAndRegist = async () => {
  try {
    emitter.emit('showLoading');
    await onSetting();
    await onRegist();
    controllerWifiSettingModal.hide();
    emitter.emit('hideLoading', true);
    
    await store.dispatch('home/fetchAllZones');

    forceRoute.value = true;
    emitter.emit('showPopAlert', {
      description: '조명제어기가 등록되었습니다.\n방 설정 화면으로 이동합니다.',
      okCallback: () => router.replace(`/settings/zones/${route.params.zoneId}/groups`),
      cancelCallback: () => router.replace(`/settings/zones/${route.params.zoneId}/groups`)
    });
  } catch (e) {
    emitter.emit('hideLoading', true);

    if (e.resultCode === "1001") {
      controllerWifiSettingModal.hide();

      emitter.emit('setLoadingText', '조명제어기를 이관하고 있습니다.');
      const transferController = async () => {
        const result = await requestTransferController(
          connectedController.value,
          account.value._id,
          e.resultData._id,
          route.params.zoneId
        );

        if (result?.resultCode === "0000") {
          forceRoute.value = true;
          emitter.emit("showPopAlert", {
            description: '이관이 완료되었습니다.',
            okCallback: () => router.go(-1),
            cancelCallback: () => router.go(-1),
          });
        } else {
          emitter.emit("showPopAlert", {
            description: '이관에 실패했습니다.'
          });
        }
      }

      emitter.emit('showPopAlert', {
        title: "등록된 조명제어기",
        description: "이미 등록된 조명제어기입니다.\n이관 처리됩니다.",
        okCallback: transferController,
        cancelCallback: transferController
      });
    } else if (e.resultCode == 2001) {

      emitter.emit('showPopAlert', {
        title: "wifi 정보 재설정",
        description: e.resultMessage,
        okCallback: setSettingModeOff,
        cancelCallback: setSettingModeOff
      });
    } else {
      console.log(e);
      showPopAlert(e);
    }
  } finally {
    emitter.emit('hideLoading', true);
  }
};

const showPopAlert = (msg) => {
  emitter.emit('showPopAlert', {
    description: msg,
  });
};

const requestDeleteController = async (payload) => {
  try {
    console.log(
      'ControllerSettingPage.onReceivedDeleteClick() => payload : ' +
        JSON.stringify(payload),
    );
    const result = await Axios.delete(
      CtrlApi.DELETE_CTRL.replace(':id', payload.id),
    );
    if (result.resultCode === '0000') {
      requestZone();
      store.commit('home/deleteController', {
        zoneId: route.params.zoneId,
        controllerId: payload.id,
      });
      return;
    }

    emitter.emit('showPopAlert', {
      description: result.resultMessage,
    });
  } catch (error) {
    console.log(error)
    emitter.emit('showPopAlert', {
      description: '조명제어기 삭제에 실패했습니다.',
    });
  }
};

const requestZone = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await Axios.get(
        ZoneApi.ZONE_INFO.replace(':id', route.params.zoneId),
      );
      if (result.resultCode === '0000') {
        zone.value = result.resultData;
        lightControllers.value = zone.value.controllers.filter(controller => controller?._id?.split("_")?.length >= 2)
        resolve(result);
      } else {
        // emitter.emit('showPopAlert', {
        //   description: result.resultMessage,
        // });
        reject(result.resultMessage);
      }
    } catch (error) {
      // emitter.emit('showPopAlert', {
      //   description: '영역 조회에 실패했습니다.',
      // });
      reject("영역 조회에 실패했습니다.");
    }
  });
};

const onReceivedDeleteClick = async (payload) => {
  // let deviceCount = 0;
  // zone.value.groups.forEach((item) => {
  //   deviceCount = deviceCount + item.devices.filter(d => d.controllerId == payload.id).length;
  // });

  // if (deviceCount > 0) {
  //   emitter.emit('showPopAlert', {
  //     description: '단말정보가 포함된 조명제어기는 삭제할 수 없습니다.',
  //   });
  //   return;
  // }

  emitter.emit('showPopConfirm', {
    description: '관련된 장치 등의 모든 데이터가 삭제됩니다.\n조명제어기를 삭제하시겠습니까?',
    okCallback: () => requestDeleteController(payload)
  });  
};
</script>
